export default __webpack_public_path__ + "static/media/hht1_ep01_le01_mini_img_01_t1_bg.b4f95a1a.png";